import { render, staticRenderFns } from "./parts.vue?vue&type=template&id=58cd9c88&scoped=true&"
import script from "./parts.vue?vue&type=script&lang=js&"
export * from "./parts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cd9c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58cd9c88')) {
      api.createRecord('58cd9c88', component.options)
    } else {
      api.reload('58cd9c88', component.options)
    }
    module.hot.accept("./parts.vue?vue&type=template&id=58cd9c88&scoped=true&", function () {
      api.rerender('58cd9c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/parts/parts/parts.vue"
export default component.exports